import { useState } from 'react';
import {
  Grid,
  Envelope,
  Shop,
  People,
  Building,
  CreditCard,
  List,
  X,
  Gear,
  ChatDots,
  FileEarmarkText
} from 'react-bootstrap-icons';

const NAV_ITEMS = {
  admin: [
    { key: 'dashboard', label: 'Dashboard', icon: Grid },
    { key: 'marketplace', label: 'Marketplace', icon: Shop },
    { key: 'quote-leads', label: 'Quote Requests', icon: Envelope },
    { key: 'professionals', label: 'Professionals', icon: People },
    { key: 'chatbot', label: 'Chatbot', icon: ChatDots },
  ],
  professional: [
    { key: 'marketplace', label: 'Marketplace', icon: Shop },
    { key: 'purchased', label: 'Purchased Leads', icon: FileEarmarkText },
    { key: 'company', label: 'Company Info', icon: Building },
    // { key: 'payment', label: 'Payment', icon: CreditCard },
  ],
  referrer: [
    { key: 'dashboard', label: 'Dashboard', icon: Grid },
    { key: 'leads', label: 'My Leads', icon: FileEarmarkText },
    { key: 'settings', label: 'Settings', icon: Gear },
  ]
};

export function AdminNav({ activeSection, onSectionChange, isAdmin, isReferrer }) {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const getNavItems = () => {
    if (isAdmin) return NAV_ITEMS.admin;
    if (isReferrer) return NAV_ITEMS.referrer;
    return NAV_ITEMS.professional;
  };

  const navItems = getNavItems();
  const currentItem = navItems.find(item => item.key === activeSection) || navItems[0];

  const handleNavClick = (key) => {
    onSectionChange(key);
    setDrawerOpen(false);
  };

  return (
    <nav className="admin-nav">
      <div className="admin-nav-container">
        {/* Desktop Navigation */}
        <div className="admin-nav-tabs">
          {navItems.map(item => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                className={`admin-nav-tab ${activeSection === item.key ? 'active' : ''}`}
                onClick={() => handleNavClick(item.key)}
              >
                <Icon />
                {item.label}
              </button>
            );
          })}
        </div>

        {/* Mobile Navigation */}
        <div className="admin-nav-mobile">
          <div className="admin-nav-mobile-current">
            {currentItem && (
              <>
                <currentItem.icon />
                {currentItem.label}
              </>
            )}
          </div>
          <button
            className="admin-nav-mobile-toggle"
            onClick={() => setDrawerOpen(true)}
            aria-label="Open navigation"
          >
            <List size={20} />
          </button>
        </div>
      </div>

      {/* Mobile Drawer Overlay */}
      <div
        className={`admin-nav-drawer-overlay ${drawerOpen ? 'open' : ''}`}
        onClick={() => setDrawerOpen(false)}
      />

      {/* Mobile Drawer */}
      <div className={`admin-nav-drawer ${drawerOpen ? 'open' : ''}`}>
        <div className="admin-nav-drawer-header">
          <img src="./qmi.png" alt="QMI" className="admin-nav-drawer-logo" />
          <button
            className="admin-nav-drawer-close"
            onClick={() => setDrawerOpen(false)}
            aria-label="Close navigation"
          >
            <X size={20} />
          </button>
        </div>
        <div className="admin-nav-drawer-items">
          {navItems.map(item => {
            const Icon = item.icon;
            return (
              <button
                key={item.key}
                className={`admin-nav-drawer-item ${activeSection === item.key ? 'active' : ''}`}
                onClick={() => handleNavClick(item.key)}
              >
                <Icon />
                {item.label}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
